import { useMemo } from "react";
import { ServiceTimesResponse } from "../../../../api/useServiceTimes";
import {
    toDate,
    getAllowedTimesForService,
    extractTimeFromDate,
    buildTimeOptions,
    isTimeValid,
    getServiceMaxDuration,
} from "./sessionFormUtils";
import { generateNoServiceTimeOptions } from "./temporaryNoServiceTimeOptions";

type UseSessionTimeOptionsParams = {
    currentServiceId: number | null;
    currentStartDate: Date | string | null | undefined;
    serviceTimesData: ServiceTimesResponse | undefined;
    servicesItems: Array<any> | undefined;
};

export const useSessionTimeOptions = ({
    currentServiceId,
    currentStartDate,
    serviceTimesData,
    servicesItems,
}: UseSessionTimeOptionsParams) => {
    const selectedServiceMaxDuration = useMemo(
        () => getServiceMaxDuration(currentServiceId, servicesItems),
        [currentServiceId, servicesItems]
    );

    const allowedTimes = useMemo(() => {
        const date = toDate(currentStartDate);
        if (!date) return null;
        return getAllowedTimesForService(currentServiceId, date, serviceTimesData);
    }, [currentStartDate, currentServiceId, serviceTimesData]);

    const currentTime = useMemo(
        () => extractTimeFromDate(currentStartDate),
        [currentStartDate]
    );

    const isTimeInvalid = useMemo(
        () => !isTimeValid(allowedTimes, currentTime),
        [allowedTimes, currentTime]
    );

    // const timeOptions = useMemo(
    //     () => buildTimeOptions(allowedTimes, currentTime),
    //     [allowedTimes, currentTime]
    // );

    const timeOptions = useMemo(() => {
        const baseTimes = currentServiceId ? allowedTimes : generateNoServiceTimeOptions();
        return buildTimeOptions(baseTimes, currentTime);
    }, [allowedTimes, currentTime, currentServiceId]);

    return {
        selectedServiceMaxDuration,
        allowedTimes,
        currentTime,
        isTimeInvalid,
        timeOptions,
    };
};

